import { useReveal } from '@/components/landing/hooks'
import { Hero, HowItWorks, Features, Preview, UseCases, ValueProps, CTABand } from '@/components/landing/sections'

// Public marketing home. Nav + Footer live in PublicLayout (the shared shell);
// this page composes the content sections only.
export default function LandingPage() {
  useReveal()
  return (
    <>
      <Hero />
      <HowItWorks />
      <Features />
      <Preview />
      <UseCases />
      <ValueProps />
      <CTABand />
    </>
  )
}
